// eslint-disable-next-line import/prefer-default-export
export const isUnknown = (val) => val?.toUpperCase() === 'UNKNOWN';
